import axios, { AxiosResponse } from 'axios';

import { getCookie, removeCookie, setCookie } from '../utils/cookiesFunctions';

const apiLambda = axios.create({
  baseURL: process.env.REACT_APP_API_LAMBDA_HOST,
  headers: {
    terminal: process.env.REACT_APP_TERMINAL,
    "request-environment": "frotas"
  },
});

// Define os nomes dos cookies utilizados
const TOKEN_KEY = 'zignet_acc_tkn';
const REFRESH_TOKEN_KEY = 'zignet_ref_tkn';

// Funções para manipular o cookie do token
export const setToken = (token: string) => {
  setCookie(TOKEN_KEY, token);
};

export const getToken = (): string | undefined => {
  return getCookie(TOKEN_KEY);
};

export const removeToken = () => {
  removeCookie(TOKEN_KEY);
};

// Funções para manipular o cookie do refreshToken
export const setRefreshToken = (refreshToken: string) => {
  setCookie(REFRESH_TOKEN_KEY, refreshToken);
};

export const getRefreshToken = (): string | undefined => {
  return getCookie(REFRESH_TOKEN_KEY);
};

export const removeRefreshToken = () => {
  removeCookie(REFRESH_TOKEN_KEY);
};

apiLambda.interceptors.request.use(
  async (config) => {
    const token = getToken();

    if (token && !config.headers.authorization) {
      config.headers.authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

apiLambda.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  async (error) => {
    const originalConfig = error.config;

    if (error?.response?.status === 403) {
      delete apiLambda.defaults.headers.common.authorization;
      removeRefreshToken();
      removeToken();
    }

    if (error?.response?.status === 401 && !originalConfig._retry) {
      originalConfig._retry = true;

      try {
        const response = await apiLambda.post('/user/refresh-login', {
          refreshToken: getRefreshToken(),
        });

        const { accessToken, refreshToken } = response?.data?.data;

        setToken(accessToken);
        setRefreshToken(refreshToken);

        return apiLambda(originalConfig);
      } catch (error) {
        removeToken();
        removeRefreshToken();

        // redireciona para a página de login
        if (typeof window !== 'undefined') {
          window.location.href = '/';
        }
      }
    }

    return Promise.reject(error);
  },
);

export { apiLambda };
